import React from 'react'
import QuestionsList from '../../Molecules/QuestionsList'
import Dropzone from '../../Molecules/Dropzone'
import { useDrop } from 'react-dnd'
import DnDItemTypes from '../../../features/dnd/DnDItemTypes'
import store from '../../../store'
import { CLONE } from '../../../features/State Management/questionsSlice'

const ExpandableTypePreview = ({ question }) => {
  const index = question?.content?.length

  const [{ canDrop }, drop] = useDrop(
    () => ({
      accept: [DnDItemTypes.QUESTION_TYPE],
      canDrop: (item) => item.label !== 'expandable',
      drop: (item) => {
        store.dispatch(
          CLONE({
            source: item.label,
            destination: {
              target: question.id, // We are targeting the subquestions of a specific question
              index: index,
            },
          })
        )
      },
      collect: (monitor) => ({
        canDrop: monitor.canDrop(),
      }),
    }),
    [index]
  )

  return (
    <div title={question.title}>
      <form>
        {question?.content?.map((question, index) => (
          <QuestionsList index={index} key={question.id} question={question} />
        ))}
        <Dropzone canDrop={canDrop} dropRef={drop} />
      </form>
    </div>
  )
}

export default ExpandableTypePreview
